import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// 🧱 Layouts
import { AppLayout } from "../components/layouts/app"; // pour les pages publiques
import { DashboardLayout } from "../components/layouts/dashboard"; // pour le dashboard

// 💫 Loader
import Loading from "../components/Loading";

/* =============================
   🌍 PAGES PUBLIQUES
============================= */
const HomePage = lazy(() => import("../pages/app/home"));
const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));

/* =============================
   🧭 PAGES DASHBOARD
============================= */
const DashboardHomePage = lazy(() => import("../pages/dashboard/dashboardhome/dashboardhome"));
const CommandesPage = lazy(() => import("../pages/dashboard/commandes/commandes"));
const FavorisPage = lazy(() => import("../pages/dashboard/favoris/favoris"));
const NotificationsPage = lazy(() => import("../pages/dashboard/notifications/notifications"));
const PanierPage = lazy(() => import("../pages/dashboard/panier/panier"));
const SettingsPage = lazy(() => import("../pages/dashboard/paramètres/parametres"));
const PartenariatPage = lazy(() => import("../pages/dashboard/partenariat/partenariat"));
const ProfilPage = lazy(() => import("../pages/dashboard/profil/profil"));
const PortefeuillePage = lazy(() => import("../pages/dashboard/portefeuille/portefeuille"));
const TransactionsPage = lazy(() => import("../pages/dashboard/transactions/transactions"));
const SupportPage = lazy(() => import("../pages/dashboard/support/support"));

/* =============================
   🚀 ROUTEUR PRINCIPAL
============================= */
const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* ===================== PUBLIC ===================== */}
        <Route element={<AppLayout />}>
          <Route path="/" element={<Suspense fallback={<Loading />}><HomePage /></Suspense>} />
        </Route>

        {/* ===================== DASHBOARD ===================== */}
            {/* ===================== DASHBOARD ===================== */}
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<Suspense fallback={<Loading />}><DashboardHomePage /></Suspense>} />
          <Route path="/dashboard/commandes" element={<Suspense fallback={<Loading />}><CommandesPage /></Suspense>} />
          <Route path="/dashboard/favoris" element={<Suspense fallback={<Loading />}><FavorisPage /></Suspense>} />
          <Route path="/dashboard/notifications" element={<Suspense fallback={<Loading />}><NotificationsPage /></Suspense>} />
          <Route path="/dashboard/panier" element={<Suspense fallback={<Loading />}><PanierPage /></Suspense>} />
          <Route path="/dashboard/parametres" element={<Suspense fallback={<Loading />}><SettingsPage /></Suspense>} />
          <Route path="/dashboard/partenariat" element={<Suspense fallback={<Loading />}><PartenariatPage /></Suspense>} />
          <Route path="/dashboard/profil" element={<Suspense fallback={<Loading />}><ProfilPage /></Suspense>} />
          <Route path="/dashboard/portefeuille" element={<Suspense fallback={<Loading />}><PortefeuillePage /></Suspense>} />
          <Route path="/dashboard/transactions" element={<Suspense fallback={<Loading />}><TransactionsPage /></Suspense>} />
          <Route path="/dashboard/support" element={<Suspense fallback={<Loading />}><SupportPage /></Suspense>} />
        </Route>

        {/* ===================== 404 ===================== */}
        <Route path="*" element={<Suspense fallback={<Loading />}><NotFoundPage /></Suspense>} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
